import Pusher from 'pusher-js'
import tabId from './tab-id'

let instance = null

/**
 * Shared Pusher connection.
 *
 * The auth token is deliberately NOT captured in this closure. It is read from
 * localStorage on every authorization request via `headersProvider`, so a token
 * rotation (AUTH_REFRESH in store/modules/auth.js) is picked up automatically
 * without rebuilding the connection.
 *
 * There is exactly one instance for the lifetime of the page. Callers may call
 * this as often as they like - they all share the same socket.
 */
export default () => {
  if (instance) {
    return instance
  }

  // Logging
  Pusher.logToConsole = process.env.NODE_ENV === 'development'

  instance = new Pusher(process.env.VUE_APP_AVANTI_PUSHER_KEY, {
    cluster: process.env.VUE_APP_AVANTI_PUSHER_CLUSTER,
    forceTLS: true,
    channelAuthorization: {
      transport: 'ajax',
      endpoint: process.env.VUE_APP_AVANTI_API_URL + '/pusher_auth.json',
      // Sent with every auth request. The API builds the presence member id from
      // it, so the same tab keeps the same identity across reconnects and does
      // not lose the objekt lock when the network changes. See BQ-331.
      params: {
        tab_id: tabId()
      },
      // Called on every auth request, so the current token is always used.
      // Note: Content-Type is intentionally not set here - pusher-js sends the
      // body as application/x-www-form-urlencoded and the API parses it as such.
      headersProvider: () => ({
        Accept: 'application/json',
        Authorization: 'Bearer ' + (localStorage.getItem('avanti-token') || '')
      })
    }
  })

  return instance
}

/**
 * Tear the shared connection down - call on logout so we don't keep a socket
 * open (and re-authorizing) for a user that is no longer signed in.
 */
export const disconnect = () => {
  if (instance) {
    instance.disconnect()
    instance = null
  }
}



// WEBPACK FOOTER //
// ./src/plugins/pusher.js